import { useState } from "react";

export const useRerender = () => {
	const [, setTick] = useState(0);
	return () => {
		setTick((tick) => tick + 1);
	};
};
